module.exports = __webpack_public_path__ + "static/img/tg3.c4b0efe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tg3.jpg
// module id = 6tVO
// module chunks = 1